import React from 'react'
import styled from 'styled-components'
import {
  compose, space, color, typography
} from 'styled-system'
import { Alert } from '@zuto/icons'
import { texts } from '@zuto/utilities'
import { TextProps } from './text-utils'

type ErrorMessageProps = React.InputHTMLAttributes<HTMLDivElement>

const StyledErrorMessage = styled.div<React.InputHTMLAttributes<HTMLDivElement> & TextProps>`
  ${texts}
  ${compose(space, color, typography)}
  display: flex;
  align-items: center;
  svg {
    flex-shrink: 0;
  }
`

const ErrorMessage = ({ children, ...props }: ErrorMessageProps) => (
  <StyledErrorMessage {...props} $variant="error" data-testid="error-message">
    <Alert data-testid="error-icon" />
    {children}
  </StyledErrorMessage>
)

export default ErrorMessage
